var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAquaman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#1da193",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.5C9 0.5 3.25 6.63 3.25 11.06C3.25 14.34 5.82 17 9 17C12.18 17 14.75 14.34 14.75 11.06C14.75 6.63 9 0.5 9 0.5ZM9 15.5C6.66 15.5 4.75 13.51 4.75 11.06C4.75 8.32 7.79 4.47 9 3.03C10.21 4.47 13.25 8.32 13.25 11.06C13.25 13.51 11.34 15.5 9 15.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.9C10.53 13.9 11.77 12.63 11.77 11.06C11.77 10.65 11.45 10.31 11.05 10.31C10.65 10.31 10.33 10.65 10.33 11.06C10.33 11.8 9.73 12.4 9 12.4C8.6 12.4 8.28 12.74 8.28 13.15C8.28 13.56 8.6 13.9 9 13.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAquaman);
export default __webpack_public_path__ + "static/media/icon_aquaman.1484e5749edd693ab40e6eed5b3caa5d.svg";
export { ForwardRef as ReactComponent };